module.exports = __webpack_public_path__ + "static/img/lj3.b02558e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lj3.png
// module id = UQmF
// module chunks = 3